export default __webpack_public_path__ + "static/media/WhereAreYouFrom_08.7be68c05.png";